module.exports = __webpack_public_path__ + "static/img/title_lwzp.cf10b6a2.png";